import ms from 'ms';

import { PaymentProviders } from '@/enums';
import { CardBrands, CreditCard, CreditCardAddress } from '@/types/CreditCard';

export const CREDIT_CARD_CACHE_TIME = ms('20m');
export const CREDIT_CARD_LOADING_TIME = ms('20s');

// reducer
export type CreditCardSlice = {
    addSubmitted: boolean;
    addSuccess: boolean;
    allowedToAddCards: boolean;
    error: string;
    laPaymentCards: CreditCard[];
    loaded: number;
    loading: boolean;
    updateSubmitted: boolean;
    updateSuccess: boolean;
    zipCard: SavedCreditCard | null;
};

export const defaultCreditCardSlice: CreditCardSlice = {
    addSubmitted: false,
    addSuccess: false,
    allowedToAddCards: true,
    error: '',
    laPaymentCards: [],
    loaded: 0,
    loading: false,
    updateSubmitted: false,
    updateSuccess: false,
    zipCard: null,
};

export type SavedCreditCard = {
    address: CreditCardAddress;
    bidderId: number;
    brand: CardBrands;
    cardBin: string;
    created: string;
    customerId: string;
    deactivatedDate: string;
    defaultCard: boolean;
    enabled: boolean;
    id: number;
    last4: string;
    lastAuthed: string;
    modified: string;
    month: string;
    name: string;
    providerCardId: string;
    providerId: PaymentProviders;
    token: string;
    year: string;
};
